import { STORAGE_KEY_OAUTH_DATA } from 'src/data/storage';
import { getQueryParams } from 'src/lib/browser';
import { useEffectOnce } from 'src/lib/hooks';
import * as storage from 'src/lib/storage';

export const IntegrationAuthCallback = () => {
  useEffectOnce(() => {
    const queryParams = getQueryParams(window.location.search);

    // HINT: disabling "postMessage" approach due to issues with COOP in Chrome
    // if (window.opener) {
    //   window.opener.postMessage(queryParams, '*');
    //   return;
    // }

    storage.writeItem(STORAGE_KEY_OAUTH_DATA, JSON.stringify(queryParams));
    window.close();
  });

  return null;
};
